import { LM_SOURCE_ID } from '../constants';
import LMFeature from '../map-geometry/LMFeature';
import LivingMap from '../map/livingmap';

export enum StateType {
  SELECTED = 'selected',
  HOVER = 'hover',
  HIGHLIGHT = 'highlight',
}

const STATE_ATTRIBUTES: StateTypeAttributeMap = {
  selected: { unique: true },
  hover: { unique: true },
  highlight: { unique: true },
};

interface StateTypeAttributeMap {
  [key: string]: StateTypeAttributes | undefined;
}

interface StateTypeAttributes {
  unique?: boolean;
}

export interface FeatureState {
  [key: string]: boolean | string | undefined;
  selected?: boolean;
  hover?: boolean;
  highlight?: boolean;
}

export type FeatureLike = LMFeature | number;

export class FeatureStateDelegate {
  private LMMap: LivingMap;
  private uniqueStateMap: { [state: string]: LMFeature };

  constructor(LMMap: LivingMap) {
    this.LMMap = LMMap;
    this.uniqueStateMap = {};
  }

  public setFeatureState(feature: FeatureLike, state: FeatureState): void {
    const lmFeature = this.resolveFeature(feature);
    const id = lmFeature.getId();

    if (!id) throw new Error('GeoJSON feature had no id');

    const source = lmFeature.getSource();
    const sourceLayer = lmFeature.getSourceLayer();

    const mapInstance = this.LMMap.getMapboxMap();
    if (source === LM_SOURCE_ID)
      mapInstance.setFeatureState({ id, source, sourceLayer }, state);
    else mapInstance.setFeatureState({ id, source }, state);

    Object.keys(state).forEach(key => {
      const stateKey = STATE_ATTRIBUTES[key];
      if (!stateKey) return;
      if (!stateKey.unique) return;

      if (state[key]) {
        this.uniqueStateMap[key] = lmFeature;
      } else {
        delete this.uniqueStateMap[key];
      }
    });
  }

  public getFeatureForState(state: StateType): LMFeature | null {
    return this.uniqueStateMap[state] ? this.uniqueStateMap[state] : null;
  }

  private resolveFeature(feature: FeatureLike): LMFeature {
    if (typeof feature !== 'number' && typeof feature !== 'string')
      return feature;
    const mapFeature = this.LMMap.queryRenderedFeatures(undefined, {
      filter: ['all', ['==', 'id', feature]],
    });
    return mapFeature[0];
  }
}
